/**
 * 难度选择场景：Easy / Normal / Hard / Lunatic（参考东方 Project 四档）。
 * ↑↓ 移动光标，Z 确认 → 选人；X 返回标题。
 */
import { VIEW_W, VIEW_H } from '../config.js';
import { Input } from '../engine/input.js';
import { menuNav } from '../engine/menu.js';
import { DIFFICULTIES } from '../content/difficulties.js';
import { t, diffName } from '../i18n.js';
import { wrapText } from '../engine/wrapText.js';

const DIFF_COLORS = ['#6cf', '#6f6', '#fc3', '#f66'];


export const DifficultySelectScene = {
  mgr: null,

  enter() {
    this.idx = 1; // 默认 Normal
    this.t = 0;
  },

  exit() {},

  update(dt) {
    this.t += dt;
    const audio = this.mgr.shared.audio;
    const nav = menuNav(Input, audio, this.idx, DIFFICULTIES.length);
    if (nav !== null) this.idx = nav;
    if (Input.pressed('confirm')) {
      audio.playSfx('select');
      this.mgr.switchTo('charSelect', { difficulty: DIFFICULTIES[this.idx] });
    }
    if (Input.pressed('cancel')) {
      audio.playSfx('cursor');
      this.mgr.switchTo('title');
    }
  },

  draw(r) {
    r.text(t('diff.title'), VIEW_W / 2, 60, { size: 24, color: '#fff', align: 'center' });
    r.text(t('diff.hint'), VIEW_W / 2, 96, { size: 11, color: '#889', align: 'center' });

    for (let i = 0; i < DIFFICULTIES.length; i++) {
      const d = DIFFICULTIES[i];
      const y = 160 + i * 100;
      const sel = i === this.idx;
      if (sel) r.rect(70, y - 10, VIEW_W - 140, 84, { fill: '#112', stroke: DIFF_COLORS[i] });
      if (sel) r.text('▶', 88, y + 8, { size: 18, color: DIFF_COLORS[i] });
      r.text(diffName(d), VIEW_W / 2, y, { size: 20, color: sel ? DIFF_COLORS[i] : '#aab', align: 'center' });
      // 难度 desc 属内容数据（difficulties.js 不改），译文按难度 id 从 i18n 取；
      // 英文较长，框内最多两行（防溢出）
      const descLines = wrapText(t(`diff.desc.${d.id}`), VIEW_W - 180, 11, 2);
      for (let k = 0; k < descLines.length; k++) {
        r.text(descLines[k], VIEW_W / 2, y + 28 + k * 15, { size: 11, color: sel ? '#99b' : '#667', align: 'center' });
      }
    }

    r.text(t('diff.note'), VIEW_W / 2, VIEW_H - 48, { size: 11, color: '#667', align: 'center' });
  },
};
